import React from "react";
import { Controller } from "react-hook-form";
import EditEscrowModal from "../../popups/EditEscrowModal";
// import EditOwnerTitleModal from "../../popups/EditOwnerTitleModal";
// import EditLenderTitleModal from "../../popups/EditLenderTitleModal";
import ControlledField from "./ControlledField";

export default function EscrowTitleFields({
  control,
  // FloatingInput,
  CustomSelect,
  getValues,
  setValue,
  openModal,
  closeModal,
  FloatingNumber,
  cleanNumber,
  // handleCurrencyBlur,
  // onFormatted,
  EscrowDisabled,
  onContinue,
}) {
  // Debug: optionally log current RHF values when this component mounts
  // useEffect(() => {
  //   try {
  //      //console.log('EscrowTitleFields values:', getValues && getValues('titleSettlementMeta'));
  //   } catch (e) {
  //     // keep safe in case console is unavailable
  //   }
  // }, [getValues]);

  return (
    <>
      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className="lbl-section">Escrow or Settlement</label>
          <Controller
            name="titleSettlementMeta.escrowSettlementPayor"
            control={control}
            defaultValue={
              getValues
                ? getValues("titleSettlementMeta.escrowSettlementPayor") ?? ""
                : ""
            }
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={
                  getValues
                    ? getValues("titleSettlementMeta.escrowSettlementPayor")
                    : ""
                }
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    // forward to RHF
                    field.onChange && field.onChange(val);

                    // determine amounts based on selected payor
                    const sellerAmount =
                      Number(
                        getValues
                          ? getValues(
                              "titleSettlementMeta.escrowSettlementSeller"
                            )
                          : 0
                      ) || 0;
                    const splitAmount =
                      Number(
                        getValues
                          ? getValues(
                              "titleSettlementMeta.escrowSettlementSplit"
                            )
                          : 0
                      ) || 0;
                    if (String(val).toLowerCase() === "buyer") {
                      setValue &&
                        setValue(
                          "titleSettlementMeta.escrowSettlementAmount",
                          0
                        );
                    } else if (String(val).toLowerCase() === "seller") {
                      setValue &&
                        setValue(
                          "titleSettlementMeta.escrowSettlementAmount",
                          sellerAmount
                        );
                    } else {
                      // Split
                      setValue &&
                        setValue(
                          "titleSettlementMeta.escrowSettlementAmount",
                          splitAmount
                        );
                    }
                  } catch (e) {
                    console.warn(
                      "Failed handling escrowSettlementPayor change",
                      e
                    );
                  }
                }}
              />
            )}
          />
        </div>
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group sign-of-amount no-m-space">
              <ControlledField
                name="titleSettlementMeta.escrowSettlementAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={
                  getValues
                    ? getValues("titleSettlementMeta.escrowSettlementAmount")
                    : ""
                }
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.escrowSettlement}
                className={
                  EscrowDisabled && EscrowDisabled.escrowSettlement === false
                    ? "premium-border"
                    : ""
                }
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.escrowSettlementAmount", value);
                }}
              />
            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Escrow / Settlement Fee",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Escrow Title Policy"
                        onClose={closeModal}
                        onContinue={(setting) =>
                          onContinue({ escrowSettlement: setting })
                        }
                      />
                    ),
                  });
                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className="lbl-section">Owners Title Policy</label>
          <Controller
            name="titleSettlementMeta.ownersTitlePayor"
            control={control}
            defaultValue={
              getValues
                ? getValues("titleSettlementMeta.ownersTitlePayor") ?? ""
                : ""
            }
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={
                  getValues
                    ? getValues("titleSettlementMeta.ownersTitlePayor")
                    : ""
                }
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    field.onChange && field.onChange(val);
                    const sellerAmount =
                      Number(
                        getValues
                          ? getValues("titleSettlementMeta.ownersTitleSeller")
                          : 0
                      ) || 0;
                    if (String(val).toLowerCase() === "buyer") {
                      setValue &&
                        setValue("titleSettlementMeta.ownersTitleAmount", 0);
                    } else if (String(val).toLowerCase() === "seller") {
                      setValue &&
                        setValue(
                          "titleSettlementMeta.ownersTitleAmount",
                          sellerAmount
                        );
                    } else {
                      // Split
                      setValue &&
                        setValue(
                          "titleSettlementMeta.ownersTitleAmount",
                          sellerAmount / 2
                        );
                    }
                  } catch (e) {
                    console.warn("Failed handling ownersTitlePayor change", e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group sign-of-amount no-m-space">
              <ControlledField
                name="titleSettlementMeta.ownersTitleAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={
                  getValues
                    ? getValues("titleSettlementMeta.ownersTitleAmount")
                    : ""
                }
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.ownersPolicy}
                className={
                  EscrowDisabled && EscrowDisabled.ownersPolicy === false
                    ? "premium-border"
                    : ""
                }
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.ownersTitleAmount", value);
                }}
              />
            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Owners Title Policy",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Owners Title Policy"
                        onClose={closeModal}
                        onContinue={(setting) =>
                          onContinue({ ownersPolicy: setting })
                        }
                      />
                    ),
                  });
                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <label className="lbl-section">Lenders Title Policy</label>
          <Controller
            name="titleSettlementMeta.lendersTitlePayor"
            control={control}
            defaultValue={
              getValues
                ? getValues("titleSettlementMeta.lendersTitlePayor") ?? ""
                : ""
            }
            render={({ field }) => (
              <CustomSelect
                {...field}
                placeholder={
                  getValues
                    ? getValues("titleSettlementMeta.lendersTitlePayor")
                    : ""
                }
                options={["Split", "Buyer", "Seller"]}
                onChange={(val) => {
                  try {
                    field.onChange && field.onChange(val);
                    const sellerAmount =
                      Number(
                        getValues
                          ? getValues("titleSettlementMeta.lendersTitleSeller")
                          : 0
                      ) || 0;
                    if (String(val).toLowerCase() === "buyer") {
                      setValue &&
                        setValue("titleSettlementMeta.lendersTitleAmount", 0);
                    } else if (String(val).toLowerCase() === "seller") {
                      setValue &&
                        setValue(
                          "titleSettlementMeta.lendersTitleAmount",
                          sellerAmount
                        );
                    } else {
                      // Split -> sellers share / 2
                      setValue &&
                        setValue(
                          "titleSettlementMeta.lendersTitleAmount",
                          sellerAmount / 2
                        );
                    }
                  } catch (e) {
                    console.warn("Failed handling lendersTitlePayor change", e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="calc-frm-fld form-group">
          <div className="calc-frm-field">
            <div className="calc-frm-fld form-group no-m-space sign-of-amount">
              <ControlledField
                name="titleSettlementMeta.lendersTitleAmount"
                control={control}
                InputComponent={FloatingNumber}
                placeholder="0.00"
                type="text"
                defaultValue={
                  getValues
                    ? getValues("titleSettlementMeta.lendersTitleAmount")
                    : ""
                }
                cleanNumber={cleanNumber}
                disabled={EscrowDisabled.lendersPolicy}
                className={
                  EscrowDisabled && EscrowDisabled.lendersPolicy === false
                    ? "premium-border"
                    : ""
                }
                onFormatted={(name, value) => {
                  setValue("titleSettlementMeta.lendersTitleAmount", value);
                }}
              />
            </div>
            <div className="calc-frm-fld form-group no-m-space edit-container">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  openModal({
                    title: "Edit Lenders Title Policy",
                    size: "smallmodel",
                    content: (
                      <EditEscrowModal
                        description="Lenders Title Policy"
                        onClose={closeModal}
                        onContinue={(setting) =>
                          onContinue({ lendersPolicy: setting })
                        }
                      />
                    ),
                  });
                }}
              >
                <i className="icon-edit" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
